import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { DirectoryAutocompleteField } from 'modules/account/common/features';

import { Field, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { SenderOrRecipientDetailsSectionProps } from './types';
import { useSenderOrRecipientDetailsSection } from './useSenderOrRecipientDetailsSection';

export const SenderOrRecipientDetailsSection = ({
  type,
}: SenderOrRecipientDetailsSectionProps) => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const {
    isDisabledAccountNumber,
    isDisabledAccountOwnerName,
    isDisabledBrokerName,
    senderOrRecipientDetails,
    isDisabledDirectoryFreeSolo,
    onChangeCustodianOrganization,
  } = useSenderOrRecipientDetailsSection({ type });

  return (
    <OrderSection
      fields={lodash.compact([
        <DirectoryAutocompleteField<{ value: string; label: string }, false>
          fullWidth
          showRequiredMark
          directoryRecordFieldFilters={
            senderOrRecipientDetails.custodianOrganization
              .directoryRecordFieldFilters
          }
          directorySchemaName={
            senderOrRecipientDetails.custodianOrganization.directorySchemaName
          }
          fieldName={senderOrRecipientDetails.custodianOrganization.fieldName}
          freeSolo={!isDisabledDirectoryFreeSolo}
          label={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.custodianOrganization.label'
          )}
          name={`${type}Details.custodianOrganization`}
          placeholder={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.custodianOrganization.placeholder'
          )}
          onChange={onChangeCustodianOrganization}
        />,

        <Field.Text
          fullWidth
          disabled={readOnly ? false : isDisabledAccountNumber}
          label={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.accountNumber.label'
          )}
          name={`${type}Details.accountNumber`}
          placeholder={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.accountNumber.placeholder'
          )}
          showRequiredMark={!isDisabledAccountNumber}
        />,
        <Field.Text
          fullWidth
          disabled={readOnly ? false : isDisabledAccountOwnerName}
          label={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.accountOwnerName.label'
          )}
          name={`${type}Details.accountOwnerName`}
          placeholder={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.accountOwnerName.placeholder'
          )}
          showRequiredMark={!isDisabledAccountOwnerName}
        />,
        <DirectoryAutocompleteField<{ value: string; label: string }, false>
          fullWidth
          directorySchemaName={
            senderOrRecipientDetails.brokerName.directorySchemaName
          }
          disabled={readOnly ? false : isDisabledBrokerName}
          fieldName={senderOrRecipientDetails.brokerName.fieldName}
          freeSolo={!isDisabledDirectoryFreeSolo}
          label={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.brokerName.label'
          )}
          name={`${type}Details.brokerName`}
          placeholder={t(
            'account.order.sections.senderOrRecipientDetailsSection.fields.brokerName.placeholder'
          )}
          showRequiredMark={!isDisabledBrokerName}
        />,
      ])}
      title={t(
        `account.order.sections.senderOrRecipientDetailsSection.title.${type}`
      )}
    />
  );
};
